/* ==========================================================================
   WOODBRASS BLOG HOME — JS
   ========================================================================== */

(function () {
  'use strict';

  /* --- HERO SLIDER --- */
  const slider = document.querySelector('.blog-hero-slider');
  if (slider) {
    const slides = slider.querySelectorAll('.slide');
    const dots = slider.querySelectorAll('.dot');
    const progressBar = slider.querySelector('.slider-progress');

    if (slides.length > 0) {
      let current = 0;
      const DURATION = 5500;
      let startTime = null;
      let rafId = null;

      function goTo(index) {
        slides[current].classList.remove('active');
        if (dots[current]) dots[current].classList.remove('active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('active');
        if (dots[current]) dots[current].classList.add('active');
        startTime = performance.now();
      }

      function tick(now) {
        if (!startTime) startTime = now;
        var elapsed = now - startTime;
        var pct = Math.min((elapsed / DURATION) * 100, 100);
        if (progressBar) progressBar.style.width = pct + '%';
        if (elapsed >= DURATION) goTo(current + 1);
        rafId = requestAnimationFrame(tick);
      }

      function startAutoplay() {
        startTime = performance.now();
        rafId = requestAnimationFrame(tick);
      }

      function stopAutoplay() {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = null;
      }

      // Init
      slides.forEach(function (s) { s.classList.remove('active'); });
      slides[0].classList.add('active');
      if (dots[0]) dots[0].classList.add('active');

      // Dot clicks
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          stopAutoplay();
          goTo(i);
          startAutoplay();
        });
      });

      // Pause on hover
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);

      // Touch swipe
      var touchStartX = 0;
      slider.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        stopAutoplay();
      }, { passive: true });

      slider.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
        startAutoplay();
      }, { passive: true });

      // Only autoplay if more than 1 slide
      if (slides.length > 1) startAutoplay();
    }
  }

  /* --- SCROLL REVEAL --- */
  var reveals = document.querySelectorAll('.blog-reveal');
  if (reveals.length > 0 && 'IntersectionObserver' in window) {
    // JS adds will-reveal first, then reveals on scroll
    // This way content is visible if JS fails
    reveals.forEach(function (el) {
      el.classList.add('will-reveal');
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.dataset.revealDelay || 0;
          setTimeout(function () {
            entry.target.classList.remove('will-reveal');
            entry.target.classList.add('revealed');
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(function (el, i) {
      el.dataset.revealDelay = i * 80;
      observer.observe(el);
    });
  }

})();